import {
  Code,
  Uri,
  ValueSetExpander,
  ValueSetResource
} from '@healthnz-prm/fhir-engine-renderer/types'
import { apiEndpointUrl, xApiKey } from '@/env'

interface ExpandValueSetOptions {
  questionnaireId: string
  authToken: string
}

export function expandValueSet(
  canonical: Parameters<ValueSetExpander>[0],
  options: Parameters<ValueSetExpander>[1],
  { questionnaireId, authToken }: ExpandValueSetOptions
): ReturnType<ValueSetExpander> {
  const url = new URL(
    `${apiEndpointUrl}/v1/nzhts/${questionnaireId}/valueset/expand?`
  )

  // omitted for filter-only items, which expand an inline value set from the compose* params
  if (canonical) url.searchParams.set('url', canonical)

  // add options to query params
  Object.entries(options || {})
    .filter(([, value]) => value !== undefined && value !== '') // filter unset keys
    .forEach(([key, value]) => url.searchParams.set(key, value))

  // if count not set in options, set a default to avoid overloading the endpoint
  if (!options?.count) {
    url.searchParams.set('count', '50')
  }

  return fetch(url, {
    headers: {
      'x-api-key': xApiKey,
      authorization: `Bearer ${authToken}`
    }
  })
    .then(res => {
      // an error body parses as JSON just fine, and would otherwise surface as an
      // empty expansion rather than an error
      if (!res.ok) {
        throw new Error(`ValueSet expansion failed: ${res.status}`)
      }
      return res.json()
    })
    .then((data: ValueSetResource) => {
      return {
        // a missing total would make every page look like the last one
        total: data.expansion?.total ?? data.expansion?.contains?.length ?? 0,
        contains:
          data.expansion?.contains?.map(contain => ({
            system: contain.system as Uri | undefined,
            code: contain.code as Code | undefined,
            display: contain.display
          })) ?? []
      }
    })
    .catch(error => {
      throw new Error(`Could not expand valueSet: ${error.message}`)
    })
}
